export default (timeStamp = '0', hours = 1) => {
  const hoursInMS = hours * 60 * 60 * 1000; // N ore in millisecondi  
  const timeSaved = parseInt(timeStamp, 10) || 0;  
  return Date.now() - hoursInMS > timeSaved;
};